import moment from "moment";

const {
  DATE_FORMATS: { DATE_YEAR_FORMAT },
} = require("../constants");

/**
 * Get the YEAR-MONTH string for when you click to view a program in a calendar
 * @param  {String} status - the program progress tracking status
 * @param  {Array{}} instances - all the program's instance information
 * @return {String} // In the form YYYY-MM, to be used like /dashboard/calendar/?month=YYYY-MM
 */
const getViewInCalendarMonth = (progress, instances) => {
  let viewInCalendarMonth;
  if (progress === "Upcoming" || progress === "Completed")
    viewInCalendarMonth = moment(
      instances.find((instance) => instance.status === progress).startDate
    ).format(DATE_YEAR_FORMAT);

  return viewInCalendarMonth;
};

export default getViewInCalendarMonth;
